<div class="flex flex-auto bg-white" [ngClass]="{'w-full h-full':openDrawer,'request-details':makeDrawerSizeFit,'dispatch-new-job-content ':!makeDrawerSizeFit}">
    <zuper-drawer class='border-l border-gray-300 shadow-none' [ngClass]="{'w-full h-full':makeDrawerSizeFit}" [name]="drawerName" [mode]="drawerMode" [fixed]="true"
      [hideOnClickOutside]="false" [position]="'right'" [transparentOverlay]="showTransparentOverlay || false" (openedChanged)="drawerOpenedChanged($event)">
        <div class="h-full w-full" *ngIf="openDrawer">
            <!-- Header -->
            <div class="flex w-full px-6 p-4 relative bg-accent-100 dark:bg-accent-700 z-0 items-start justify-between">
                <div class="flex items-center">
                    <h2 class="text-xl font-semibold primary-font">
                        {{'create.new_job.text' | translate}}</h2>
                </div>
                <div class="ml-auto flex h-7 items-center">
                    <div class="text-base text-primary font-medium cursor-pointer hover:underline mr-2"
                        (click)="advancedJobCreation()">
                        {{'detailed.view.job' | translate}}
                    </div>
                    <div class="flex flex-shrink-0 ml-auto cursor-pointer rounded-full w-10 h-10 hover:bg-gray-200 items-center justify-center -mr-1"
                        matTooltip="{{'close.text' | translate}}" matTooltipPosition="left" (click)="closeNewJob()">
                        <em class="ti ti-x text-xl"></em>
                    </div>
                </div>
            </div>
            <!-- Time Zone Alert -->
            <div class="rounded-md bg-blue-50 m-4 px-4 py-3 border-l-8 border-blue-700" *ngIf="showTimezoneAlert">
                <div class="flex items-center">
                    <div class="flex-shrink-0"><em class="ti ti-alert-circle text-blue-700 text-2xl"></em></div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700">{{'new.job.time_zone.content' | translate}}
                            {{timezoneDisplayName}}, <span class="font-medium">{{customTimezone}}</span></p>
                    </div>
                </div>
            </div>
            <!-- Error Message -->
            <div class="rounded-md bg-red-50 m-4 px-4 py-3 border-l-8 border-red-500" *ngIf="showErrorMessage">
                <div class="flex items-center">
                    <div class="flex-shrink-0"><em class="ti ti-alert-circle text-red-500 text-2xl"></em></div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-red-500">{{errorMessage}}</p>
                    </div>
                </div>
            </div>
            <!-- project message -->
            <div class="rounded-md bg-blue-50 m-4 px-4 py-3 border-l-8 border-blue-700"
                *ngIf="parentModuleData?.module === 'PROJECT'">
                <div class="flex items-center">
                    <div class="flex-shrink-0"><em class="ti ti-info-circle text-blue-700 text-2xl"></em></div>
                    <div class="ml-3 flex-1 md:flex md:justify-between">
                        <p class="text-base text-blue-700 line-clamp-2">
                            {{'text.project.new_job_message' | translate}} (<span
                                *ngIf="parentModuleData?.moduleData?.project_number">
                                #{{parentModuleData.moduleData.project_number}} - </span> <span
                                *ngIf="parentModuleData?.moduleData?.project_name">{{parentModuleData.moduleData.project_name}}</span>)
                        </p>
                    </div>
                </div>
            </div>
            <!-- Body -->
            <div class="dispatch-new-job-body-container overflow-y-auto overflow-x-hidden zuper-scrollbar"
                [ngClass]="{ 'error-container-visible' : showErrorMessage, 'timezone-container-visible': showTimezoneAlert , 'project-banner-visible':parentModuleData?.module === 'PROJECT'}">
                <!-- Job Form -->
                <form class="primary-font dispatch-new-job-form" autocomplete="off" [formGroup]="newJobForm">
                    <div class="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                        <!-- Job Title -->
                        <div class="grid grid-cols-6 gap-4 px-6 pb-5">
                            <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-600">
                                <label class="text-gray-600">
                                    {{'text.job_title' | translate}}
                                </label>
                                <span class="text-red-500 ml-0.5">*</span>
                            </div>
                            <div class="col-span-4">
                                <input type="text" name="title" id="title" formControlName="jobTitle"
                                    class="mt-4 block w-full rounded-md border bg-white px-3 py-3 leading-none text-base"
                                    placeholder="{{ 'text.job_title' | translate}}"
                                    [ngClass]="{'border-red-500': showError('jobTitle'), 'border-gray-300 focus:border-indigo-500': !showError('jobTitle')}">
                                <p class="text-red-500 text-base mt-1" *ngIf="showError('jobTitle')">
                                    {{'text.field_is_required' | translate}}</p>
                            </div>
                        </div>
                        <!-- Job Description -->
                        <div class="grid grid-cols-6 gap-4 px-6 pb-5">
                            <div class="col-span-2 break-words flex items-center text-base font-medium text-gray-600">
                                <label class="text-gray-600">
                                    {{'text.job_description' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4">
                                <div class="mt-1 h-60" *ngIf="showEditor">
                                    <text-editor
                                        [editorData]="newJobForm?.controls?.jobDescription"
                                        [options]="textEditorOptions"
                                        (editorInput)="onEditorInput($event)" 
                                        [ngClass]="{'border-red-500': showError('jobDescription'), 'border-gray-300 focus:border-indigo-500': !showError('jobDescription')}"
                                        style="font-size: 14px;"
                                    ></text-editor>
                                    <div *ngIf="showError('jobDescription')" class="text-red-500 text-sm mt-1">
                                        {{ 'text.job_description_error' | translate }}
                                    </div>
                                </div>
                            </div>                          
                        </div>
                        <!-- Customer -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5"
                            *ngIf="utilityService.hasModuleAccess('CUSTOMER')">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'customer' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select #jobCustomer class="job-form-select-field" [items]="customers | async"
                                        [multiple]="false" formControlName="customer" bindValue="customer_uid"
                                        [loading]="customerFetching" appendTo="body" [closeOnSelect]="true"
                                        [typeahead]="customerValueSubject" (clear)="onCustomerClear()"
                                        (search)="onCustomerSearch()" (scrollToEnd)="onCustomerScrollToEnd()"
                                        placeholder="{{'text.select_customer' | translate}}"
                                        (change)="changeJobCustomer($event)">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base text-gray-600">
                                                <p class="font-semibold">
                                                    {{item.customer_first_name}} {{item.customer_last_name ?? ''}}
                                                </p>
                                                <p *ngIf="item.customer_email">
                                                    {{item.customer_email}}
                                                </p>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                            <span class="ng-value-label">{{item.customer_first_name}}
                                                {{item.customer_last_name ?? ''}}</span>
                                        </ng-template>
                                        <ng-template ng-footer-tmp *ngIf="utilityService.hasPermission('customer.new')">
                                            <div class="primary-font text-base text-gray-600 flex justify-center items-center cursor-pointer font-medium text-primary-600"
                                                (click)="createNewCustomer(jobCustomer)">
                                                {{'create.new_customer.text' | translate}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <p class="text-red-500 text-base mt-1" *ngIf="showError('customer')">
                                        {{'text.field_is_required' | translate}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Organization -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5"
                            *ngIf="utilityService.hasModuleAccess('ORGANIZATION')">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.organization' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select #jobOrganization class="job-form-select-field"
                                        [items]="organizations | async" [multiple]="false"
                                        formControlName="organization" bindValue="organization_uid"
                                        [loading]="organizationFetching" appendTo="body" [closeOnSelect]="true"
                                        [typeahead]="organizationValueSubject" (clear)="onOrganizationClear()"
                                        (search)="onOrganizationSearch()" (scrollToEnd)="onOrganizationScrollToEnd()"
                                        placeholder="{{'text.select_organization' | translate}}"
                                        (change)="changeJobOrganization($event)">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base text-gray-600">
                                                <p class="font-semibold">
                                                    {{item.organization_name}}
                                                </p>
                                                <p *ngIf="item.organization_email">
                                                    {{item.organization_email}}
                                                </p>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                            <span class="ng-value-label">{{item.organization_name}}</span>
                                        </ng-template>
                                        <ng-template ng-footer-tmp
                                            *ngIf="utilityService.hasPermission('organization.new')">
                                            <div class="primary-font text-base text-gray-600 flex justify-center items-center cursor-pointer font-medium text-primary-600"
                                                (click)="createNewOrganization(jobOrganization)">
                                                {{'new.job.organization.create_new' | translate}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <p class="text-red-500 text-base mt-1" *ngIf="showError('organization')">
                                        {{'text.field_is_required' | translate}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Property -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5"
                            *ngIf="utilityService.hasModuleAccess('PROPERTY')">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.property' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select #jobProperty class="job-form-select-field" [items]="properties | async"
                                        [multiple]="false" formControlName="property" bindValue="property_uid"
                                        [loading]="propertyFetching" appendTo="body" [closeOnSelect]="true"
                                        [typeahead]="propertyValueSubject" (clear)="onPropertyClear()"
                                        (search)="onPropertySearch()" (scrollToEnd)="onPropertyScrollToEnd()"
                                        placeholder="{{'text.select_property' | translate}}"
                                        (change)="changeJobProperty($event)">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base text-gray-600">
                                                {{item.property_name}}
                                            </div>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                            <span class="ng-value-label">{{item.property_name}}</span>
                                        </ng-template>
                                        <ng-template ng-footer-tmp *ngIf="utilityService.hasPermission('property.new')">
                                            <div class="primary-font text-base text-gray-600 flex justify-center items-center cursor-pointer font-medium text-primary-600"
                                                (click)="createNewProperty(jobProperty)">
                                                {{'new.job.property.create_new' | translate}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <p class="text-red-500 text-base mt-1" *ngIf="showError('property')">
                                        {{'text.field_is_required' | translate}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Job Category -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'category.text' | translate}}
                                </label>
                                <span class="text-red-500 ml-0.5">*</span>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select #jobCategory class="job-form-select-field" [items]="categories"
                                        bindLabel="category_name" bindValue="category_uid" [multiple]="false"
                                        [loading]="categoryFetching" [searchable]="true" appendTo="body"
                                        (change)="changeJobCategory($event)"
                                        placeholder="{{'text.select_category' | translate}}" [clearable]="false"
                                        formControlName="category" [hideSelected]="false" [closeOnSelect]="true">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base text-gray-600">
                                                {{item.category_name}}
                                            </div>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                            <span class="ng-value-label">{{item.category_name}}</span>
                                        </ng-template>
                                        <ng-template ng-footer-tmp *ngIf="userRole === 'ADMIN'">
                                            <div class="primary-font text-base text-gray-600 flex justify-center items-center cursor-pointer font-medium text-primary-600"
                                                (click)="createNewCategory(jobCategory)">
                                                {{'new.job.category.create_new' | translate}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <p class="text-red-500 text-base mt-1" *ngIf="showError('category')">
                                        {{'text.field_is_required' | translate}}</p>
                                </div>
                            </div>
                        </div>
                        <!-- Job Tags -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.tags' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <tags-component class="mt-1" [options]="tagsOption"
                                        (tagsChanged)="changeTags($event)"></tags-component>
                                </div>
                            </div>
                        </div>
                        <!-- Job Priority -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.priority' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select class="job-form-select-field" [items]="priorityTypes"
                                        bindLabel="priorityType" bindValue="priorityKey" [clearable]="false"
                                        [searchable]="false" [hideSelected]="false" appendTo="body"
                                        placeholder="{{'text.select_priority' | translate}}" formControlName="priority">
                                        <ng-template ng-option-tmp let-item="item">
                                            <div class="primary-font text-base flex items-center">
                                                {{item.priorityType}}
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- Due Date -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-6">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'due.date.text' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 flex">
                                <div class="w-full relative">
                                    <input [matDatepicker]="due_date" type="text" name="due_date" id="due_date"
                                        [min]="today"
                                        class="w-full mt-0.5 mr-4 block rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                                        placeholder="{{'due.date.text' | translate}}" (click)="due_date.open()"
                                        [datePickerFormat]="dateFormat" formControlName="dueDate" readonly>
                                    @if (newJobForm?.value?.dueDate) {
                                    <div class="w-full text-right text-primary absolute -top-6 right-0 mt-0.5">
                                        <span class="hover:underline cursor-pointer" (click)="clearDueDate()">{{'overall_search.recently_viewed.clear' |
                                            translate}}</span>
                                    </div>
                                    }
                                    <mat-datepicker #due_date></mat-datepicker>
                                </div>
                            </div>
                        </div>
                        <!-- Assigned To -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.assigned_to' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4">
                                <div class="w-full">
                                    <ng-select class="job-form-select-field" [items]="employees | async"
                                        [multiple]="true" [loading]="employeeFetching" appendTo="body"
                                        [closeOnSelect]="false" [typeahead]="employeeValueSubject"
                                        (clear)="onEmployeeClear()" (search)="onEmployeeSearch()"
                                        (change)="onEmployeeChange()" (scrollToEnd)="onEmployeeScrollToEnd()"
                                        [searchable]="true" appendTo="body"
                                        placeholder="{{'text.search_user' | translate}}" [clearable]="false"
                                        formControlName="assignedTo" [hideSelected]="false">
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <div class="primary-font text-base flex items-center">
                                                <input id="item-{{index}}" type="checkbox" class="mr-4"
                                                    [checked]="isEmployeeAssigned(item)"
                                                    (change)="jobObject?.assigned_to?.length ? userSelectionChanged($event, item) : $event.stopPropagation()" />
                                                <div class="primary-font text-base text-gray-600">
                                                    <p class="font-semibold">
                                                        {{item.first_name}} {{item.last_name ?? ''}}
                                                    </p>
                                                    <p *ngIf="item.teams?.length">
                                                        {{item.teams[0]?.team_name}}
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <ng-template ng-multi-label-tmp>
                                            <span style="display:block" *ngIf="!employeePagination.keyword"
                                                class="ng-placeholder">{{'text.search_user' |
                                                translate}}</span>
                                        </ng-template>
                                    </ng-select>
                                </div>
                                <div class="divide-y divide-gray-200 mt-2" *ngIf="newJobForm.value?.assignedTo?.length">
                                    <ng-container *ngFor="let user of newJobForm.value?.assignedTo;let i=index">
                                        <div class="flex items-center py-1.5" *ngIf="user">
                                            <div matTooltip="{{user?.first_name}} {{user?.last_name ?? ''}}"
                                                class="flex flex-shrink-0 bg-gray-200 rounded-md items-center text-base justify-center h-10 w-10 mr-2">
                                                {{user?.first_name[0]}}
                                            </div>
                                            <div class="w-2/3 truncate">
                                                <p class="text-base font-medium">
                                                    {{user?.first_name}} {{user?.last_name ?? ''}}
                                                </p>
                                                <p class="text-md" *ngIf="user.teams?.length || user?.role">
                                                    <span class="pr-2"
                                                        *ngIf="user?.role">{{user?.role?.role_name}}</span>
                                                    <span class="border-l border-gray-400 pl-2"
                                                        *ngIf="user.teams?.length">{{getEmployeeTeam(user)}}</span>
                                                </p>
                                            </div>
                                            <div class="flex ml-auto items-center">
                                                <a matTooltip="{{'text.unassign' | translate}}"
                                                    (click)="unassignEmployee(user)"
                                                    class="flex flex-shrink-0 hover:bg-red-100 rounded-full items-center justify-center h-8 w-8 cursor-pointer">
                                                    <em class="ti ti-user-x text-xl text-red-500"></em>
                                                </a>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-6 gap-4 px-6 py-5" *ngIf="utilityService.isTimeZoneEnabled">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600"
                                    class="block text-base font-medium text-gray-700">
                                    {{"preferred.timezone" | translate}}</label>
                            </div>

                            <div class="col-span-4 flex">
                                <div class="w-full">
                                    <ng-select #customerCustomTimezone class="w-full mt-1" [items]="timeZoneData"
                                        [formControlName]="'job_timezone'" [clearable]="false" [multiple]="false"
                                        [hideSelected]="true" bindValue="key" bindLabel="display_name" 
                                        [searchFn]="timezoneService.customTimezoneSearch"
                                        [placeholder]="'text.choose_timezone' | translate"
                                        >
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <!-- Scheduled On -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-6">
                            
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-6">
                                <label class="text-gray-600">
                                    {{'text.scheduled_on' | translate}}
                                </label>
                            </div>
                            <div class="col-span-4 space-y-4">
                                <div class="w-full relative">
                                    <input [ngxMatDatetimePicker]="start_date_picker" type="text" name="start_date"
                                        id="start_date"
                                        class="w-full mt-0.5 mr-4 block rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                                        placeholder="{{'new.job.schedule_start_date.placeholder' | translate}}"
                                        (click)="setDate(start_date_picker,'scheduleStartDate')"
                                        [datePickerFormat]="dateTimeFormat"
                                        (dateChange)="changeScheduledStartDate($event)"
                                        formControlName="scheduleStartDate" readonly>
                                    <ngx-mat-datetime-picker #start_date_picker [showSpinners]="true" [showSeconds]="false"
                                        [stepHour]="1" [stepMinute]="15" [stepSecond]="1" [touchUi]="false"
                                        [enableMeridian]="enableMeridian()" [disableMinute]="false">
                                        <ngx-mat-datepicker-actions>
                                            <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                                        </ngx-mat-datepicker-actions>
                                    </ngx-mat-datetime-picker>
                                    @if (newJobForm?.value?.scheduleStartDate || newJobForm?.value?.scheduleEndDate) {
                                        <div class="w-full text-right text-primary absolute -top-[23px] right-0 mt-0.5">
                                            <span class="hover:underline cursor-pointer" (click)="clearScheduledDate()">{{'overall_search.recently_viewed.clear' | translate}}</span>
                                        </div>
                                    }
                                </div>
                                <div class="w-full">
                                    <input [ngxMatDatetimePicker]="to_date_picker" type="text" name="to_date" id="to_date"
                                        class="w-full mt-0.5 mr-4 block rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base cursor-pointer"
                                        placeholder="{{'new.job.schedule_end_date.placeholder' | translate}}" [min]="newJobForm?.value.scheduleStartDate"
                                        (click)="setDate(to_date_picker,'scheduleEndDate')"
                                        [datePickerFormat]="dateTimeFormat" formControlName="scheduleEndDate" readonly>
                                    <ngx-mat-datetime-picker #to_date_picker [showSpinners]="true" [showSeconds]="false"
                                        [stepHour]="1" [stepMinute]="15" [stepSecond]="1" [touchUi]="false"
                                        [enableMeridian]="enableMeridian()" [disableMinute]="false">
                                        <ngx-mat-datepicker-actions>
                                            <button mat-flat-button color="primary" ngxMatDatepickerApply>{{'text.ok' | translate}}</button>
                                        </ngx-mat-datepicker-actions>
                                    </ngx-mat-datetime-picker>
                                </div>
                            </div>
                        </div>
                        <!-- Service Address -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'text.service_address' | translate}}
                                </label>
                                <span class="text-red-500 ml-0.5">*</span>
                            </div>
                            <div class="col-span-4">
                                <div class="w-full -mt-2">
                                    <contact-info class="new-job-contact-info" [fields]="serviceAddressFields"
                                        [addressFormGroupName]="serviceAddressForm">
                                    </contact-info>
                                </div>
                            </div>
                        </div>
                        <!-- Billing Address -->
                        <div class="grid grid-cols-6 gap-4 px-6 py-5">
                            <div class="col-span-2 break-words flex text-base font-medium text-gray-600 mt-3">
                                <label class="text-gray-600">
                                    {{'billing.address.text' | translate}}
                                </label>
                                <span class="text-red-500 ml-0.5">*</span>
                            </div>
                            <div class="col-span-4">
                                <div class="flex justify-start items-center font-medium text-base pr-2 py-4">
                                    <input id="sameAsServiceAddress" formControlName="sameAsServiceAddress"
                                        type="checkbox" (change)="onBillingAddressFlagChange($event)"
                                        class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded">
                                    <label for="sameAsServiceAddress"
                                        class="block text-base text-gray-600 ml-3 cursor-pointer leading-tight">{{"text.same_as_service_address"
                                        | translate}}</label>
                                </div>
                                <div class="w-full -mt-2" *ngIf="!newJobForm.value?.sameAsServiceAddress">
                                    <contact-info class="new-job-contact-info" [fields]="billingAddressFields"
                                        [addressFormGroupName]="billingAddressForm">
                                    </contact-info>
                                </div>
                            </div>
                        </div>
                        @if (showCustomFields) {
                            <!-- Custom Fields  -->
                            <div class="w-full">
                                <app-custom-field-form [config]="customFieldConfig" [options]="customFieldOptions" [formGroup]="newJobForm.controls?.customFields" [category]="currentCategoryId"></app-custom-field-form>
                            </div>
                        }
                    </div>
                    
                </form>
            </div>
            <!-- Footer -->
            <div class="dispatch-new-job-footer-container w-full px-2 py-4 space-y-4 border-t border-gray-100">
                <div class="w-full px-4 flex justify-end gap-4">
                    <button mat-stroked-button (click)="closeNewJob()"
                        class="h-10 min-h-10 px-4 py-2 items-center border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white hover:bg-gray-50 focus:outline-none">
                        {{'cancel.text' | translate}}
                    </button>
                    <button type="button" (click)="createNewJob()" [disabled]="serviceTaskLoading"
                        class="bg-primary px-4 py-2 h-10 flex justify-center items-center border-gray-300 shadow-sm text-white text-base font-medium rounded-md text-white-600 focus:outline-none">
                        <mat-spinner [diameter]="18" class="mr-2" *ngIf="creatingJob"></mat-spinner>
                        {{'create' | translate}}
                    </button>
                </div>
            </div>
        </div>
    </zuper-drawer>
</div>

<data-picker (eventEmitter)="dataPickerEventHandler($event)" [openPicker]="openDataPicker" [module]="drawerModule"
    [options]="getDataPickerOptions()"></data-picker>